<template>
  <div>
    <el-row :gutter="15">
      <el-col :span="12">
        <el-card class="card" style="height: 415px;">
          <div id="map" class="map">
          </div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-row :gutter="15">
          <el-col :span="12">
            <el-card class="card" style="height: 200px;">
              <div slot="header" class="card-header"
                style="text-align: center;font-size: 16px;font-weight:bold;letter-spacing: 4px;">
                故障信息
              </div>
              <el-col :span="12">
                <el-row>
                  <div @click="add_fau_tab()">
                    <el-col :span="16" class="tatistic-key">现存故障数</el-col>
                    <el-col :span="8" class="tatistic-value">
                      <div style="margin-left: 30px;">
                        {{ faultlist.length }}
                      </div>
                    </el-col>
                  </div>
                </el-row>
                <el-row>
                  <div @click="add_fau_tab()">
                    <el-col :span="16" class="tatistic-key">今日发生故障数</el-col>
                    <el-col :span="8" class="tatistic-value">
                      <div style="margin-left: 30px;">{{ faultInfo.todayOccuCount }}</div>
                    </el-col>
                  </div>
                </el-row>
                <el-row>
                  <div @click="add_fau_tab()">
                    <el-col :span="16" class="tatistic-key">今日解决故障数</el-col>
                    <el-col :span="8" class="tatistic-value">
                      <div style="margin-left: 30px;">{{ faultInfo.todaySolveCount }}</div>
                    </el-col>
                  </div>
                </el-row>
              </el-col>
              <el-col :span="12">
                <div @click="add_fau_tab()" id="finishRatePanel" style="height:150px;"></div>
              </el-col>
            </el-card>
          </el-col>
          <el-col :span="12">
            <el-card class="card" style="height: 200px;">
              <div slot="header" class="card-header"
                style="text-align: center;font-size: 16px;font-weight:bold;letter-spacing: 4px;">
                巡检信息</div>
              <el-col :span="12">
                <el-row>
                  <div @click="add_ins_tab()">
                    <el-col :span="16" class="tatistic-key">今日巡检计划</el-col>
                    <el-col :span="8" class="tatistic-value">
                      <div style="margin-left: 30px;">
                        {{ faultInfo.planCount == null ? 0 : faultInfo.planCount }}
                      </div>
                    </el-col>
                  </div>
                </el-row>
                <el-row>
                  <div @click="add_ins_tab()">
                    <el-col :span="16" class="tatistic-key">今日完成巡检项</el-col>
                    <el-col :span="8" class="tatistic-value">
                      <div style="margin-left: 30px;">{{ faultInfo.todayFinishPlanItemCount }}</div>
                    </el-col>
                  </div>
                </el-row>
                <el-row>
                  <div @click="add_ins_tab()">
                    <el-col :span="16" class="tatistic-key">今日巡检项</el-col>
                    <el-col :span="8" class="tatistic-value">
                      <div style="margin-left: 30px;">{{ faultInfo.todayPlanItemCount }}</div>
                    </el-col>
                  </div>
                </el-row>
              </el-col>
              <el-col :span="12">
                <div @click="add_ins_tab()" id="insFinishRatePanel" style="height:150px;"></div>
              </el-col>
            </el-card>
          </el-col>
        </el-row>
        <el-row :gutter="15" style="margin-top:15px">
          <el-col :span="12">
            <el-card class="card" style="height: 200px;">
              <div slot="header" class="card-header"
                style="text-align: center;font-size: 16px;font-weight:bold;letter-spacing: 4px;">
                维修信息</div>
              <el-col>
                <el-row>
                  <div class="context-div">
                    <el-col :span="8">
                      <div @click="add_repair_tab()">
                        <el-row class="context-value">
                          {{ faultInfo.nofinishRepair }}
                        </el-row>
                        <el-row class="context-key">
                          现存维修
                        </el-row>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div @click="add_repair_tab()">
                        <el-row class="context-value">
                          {{ faultInfo.todayOccuRepairCount }}
                        </el-row>
                        <el-row class="context-key">
                          今日维修
                        </el-row>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div @click="add_repair_tab()">
                        <el-row class="context-value">
                          {{ faultInfo.todaySolveRepairCount }}
                        </el-row>
                        <el-row class="context-key">
                          今日解决
                        </el-row>
                      </div>
                    </el-col>
                  </div>
                </el-row>
              </el-col>
            </el-card>
          </el-col>
          <el-col :span="12">
            <el-card class="card" style="height: 200px;">
              <div slot="header" class="card-header"
                style="text-align: center;font-size: 16px;font-weight:bold;letter-spacing: 4px;">
                人员管理</div>
              <el-col>
                <el-row>
                  <div class="context-div">
                    <el-col :span="8">
                      <div @click="add_user_tab()">
                        <el-row class="context-value">
                          {{ faultInfo.userCount }}
                        </el-row>
                        <el-row class="context-key">
                          现场人员
                        </el-row>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div @click="add_duty_tab()">
                        <el-row class="context-value">
                          {{ faultInfo.dutyCount }}
                        </el-row>
                        <el-row class="context-key">
                          在班人员
                        </el-row>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div @click="add_user_tab()">
                        <el-row class="context-value">
                          {{ faultInfo.userCount - faultInfo.dutyCount }}
                        </el-row>
                        <el-row class="context-key">
                          休假人员
                        </el-row>
                      </div>
                    </el-col>
                  </div>
                </el-row>
              </el-col>
            </el-card>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row :gutter="15">
      <el-col :span="12" style="margin-top: 15px;">
        <el-card class="card" style="height: 220px;">
          <el-col :span="6">
            <div @click="add_task_tab()" class="tatistic-div">
              <el-row class="tatistic-value">
                <div style="margin-top: 20px;">
                  {{ faultInfo.todayTaskCount == null ? 0 : faultInfo.todayTaskCount }}
                </div>
              </el-row>
              <el-row class="tatistic-key">
                今日任务
              </el-row>
            </div>
          </el-col>
          <el-col :span="6">
            <div @click="add_task_tab()" class="tatistic-div">
              <el-row class="tatistic-value">
                <div style="margin-top: 20px;">
                  {{ faultInfo.todayFinishTaskCount }}
                </div>
              </el-row>
              <el-row class="tatistic-key">
                今日完成任务
              </el-row>
            </div>
          </el-col>
          <el-col :span="6">
            <div @click="add_maintain_tab()" class="tatistic-div">
              <el-row class="tatistic-value">
                <div style="margin-top: 20px;">
                  {{ faultInfo.todayMaintainCount == null ? 0 : faultInfo.todayMaintainCount }}
                </div>
              </el-row>
              <el-row class="tatistic-key">
                今日保养
              </el-row>
            </div>
          </el-col>
          <el-col :span="6">
            <div @click="add_maintain_tab()" class="tatistic-div" style="">
              <el-row class="tatistic-value">
                <div style="margin-top: 20px;">
                  {{ faultInfo.todayFinishMaintainCount }}
                </div>
              </el-row>
              <el-row class="tatistic-key">
                今日完成保养
              </el-row>
            </div>
          </el-col>
          <el-col :span="6">
            <div @click="add_mat_tab()" class="tatistic-div">
              <el-row class="tatistic-value">
                <div style="margin-top: 20px;">
                  {{ faultInfo.matConsumes == null ? 0 : faultInfo.matConsumes }}
                </div>
              </el-row>
              <el-row class="tatistic-key">
                故障材料使用
              </el-row>
            </div>
          </el-col>
          <el-col :span="6">
            <div @click="add_mat_tab()" class="tatistic-div">
              <el-row class="tatistic-value">
                <div style="margin-top: 20px;">
                  {{ faultInfo.matRepairConsumes }}
                </div>
              </el-row>
              <el-row class="tatistic-key">
                维修材料使用
              </el-row>
            </div>
          </el-col>
          <el-col :span="6">
            <div @click="add_asset_tab()" class="tatistic-div">
              <el-row class="tatistic-value">
                <div style="margin-top: 20px;">
                  {{ faultInfo.assetCount }}
                </div>
              </el-row>
              <el-row class="tatistic-key">
                设备管理
              </el-row>
            </div>
          </el-col>
        </el-card>
      </el-col>
      <el-col :span="12" style="margin-top: 15px;">
        <el-card class="card" style="height: 220px;">
          <div id="eleDayFaultHis" @click="add_fau_tab()" style="height: 240px;margin-top: -20px;width: 100%;">
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="15">
      <el-col style="margin-top: 15px;">
        <div @click="add_fau_tab()">
          <el-card class="card" style="height: calc(100vh - 780px);overflow-y: auto;">
            <el-table :data="faultInfo.nofinishFaults" ref="fauTable" show-overflow-tooltip border stripe size="mini"
              height="calc(100vh - 805px)" v-loading="loading">
              <el-table-column type="index" label="序号" width="50" align="center">
              </el-table-column>
              <el-table-column prop="code" label="故障单号">
              </el-table-column>
              <el-table-column prop="org_name" label="组织名称">
              </el-table-column>
              <el-table-column prop="area_name" label="区域名称">
              </el-table-column>
              <el-table-column prop="equi_name" label="设备名称">
              </el-table-column>
              <el-table-column prop="level_name" label="故障等级">
              </el-table-column>
              <el-table-column prop="duration" label="规定时长">
                <template slot-scope="scope">
                  <span style="color:orange">{{ scope.row.duration }}小时</span>
                </template>
              </el-table-column>
              <el-table-column prop="planSolveTime" label="规定完成时间">
                <template slot-scope="scope">
                  <span style="color:orange">{{ scope.row.planSolveTime }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="appeName" :show-overflow-tooltip=true label="故障现象">
                <template slot-scope="scope">
                  <span>{{
                    scope.row.appe_id == 999999 ? (scope.row.des == null ? '' : scope.row.des) :
                    scope.row.appe_name
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="state" label="状态" width="110" align="center">
                <template slot-scope="scope">
                  <el-tag size="mini" :type="stateFormat(scope.row, 1)">{{ scope.row.statename }}</el-tag>
                  <el-tag size="mini" type="danger" style="margin-left:4px"
                    v-if="scope.row.process != null && scope.row.process.startsWith('挂起')">挂起</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="occu_time" label="故障上报时间">
              </el-table-column>
            </el-table>
          </el-card>
        </div>
      </el-col>
    </el-row>

    <el-dialog :visible.sync="wrnameDataMessView" @closed="() => this.$refs['wrnameDataMessViewForm'].clearValidate()"
      width="800px">
      <div class="card-header" style="text-align: center;font-size: 20px;font-weight:bold;letter-spacing: 4px;">
        {{ wrnameDataMess.name }}</div>
      <el-row :gutter="15">
        <el-col style="margin-top: 15px;">
          <el-col :span="6">
            <div class="tatistic-dialog-div">
              <el-row class="tatistic-value">
                <div style="margin-top: 20px;">
                  {{ wrnameDataMess.nofinishFaults == null ? 0 : wrnameDataMess.nofinishFaults }}
                </div>
              </el-row>
              <el-row class="tatistic-key">
                现存故障数
              </el-row>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="tatistic-dialog-div">
              <el-row class="tatistic-value">
                <div style="margin-top: 20px;">
                  {{ wrnameDataMess.todayOccuCount }}
                </div>
              </el-row>
              <el-row class="tatistic-key">
                今日发生故障数
              </el-row>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="tatistic-dialog-div">
              <el-row class="tatistic-value">
                <div style="margin-top: 20px;">
                  {{ wrnameDataMess.todaySolveCount }}
                </div>
              </el-row>
              <el-row class="tatistic-key">
                今日解决故障数
              </el-row>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="tatistic-dialog-div">
              <el-row class="tatistic-value">
                <div style="margin-top: 20px;">
                  {{ wrnameDataMess.assetCount }}
                </div>
              </el-row>
              <el-row class="tatistic-key">
                设备管理
              </el-row>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="tatistic-dialog-div">
              <el-row class="tatistic-value">
                <div style="margin-top: 20px;">
                  {{ wrnameDataMess.todayTaskCount == null ? 0 : wrnameDataMess.todayTaskCount }}
                </div>
              </el-row>
              <el-row class="tatistic-key">
                今日任务
              </el-row>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="tatistic-dialog-div">
              <el-row class="tatistic-value">
                <div style="margin-top: 20px;">
                  {{ wrnameDataMess.todayFinishTaskCount }}
                </div>
              </el-row>
              <el-row class="tatistic-key">
                今日完成任务
              </el-row>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="tatistic-dialog-div">
              <el-row class="tatistic-value">
                <div style="margin-top: 20px;">
                  {{ wrnameDataMess.todayMaintainCount == null ? 0 : wrnameDataMess.todayMaintainCount }}
                </div>
              </el-row>
              <el-row class="tatistic-key">
                今日保养
              </el-row>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="tatistic-dialog-div" style="">
              <el-row class="tatistic-value">
                <div style="margin-top: 20px;">
                  {{ wrnameDataMess.todayFinishMaintainCount }}
                </div>
              </el-row>
              <el-row class="tatistic-key">
                今日完成保养
              </el-row>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="tatistic-dialog-div">
              <el-row class="tatistic-value">
                <div style="margin-top: 20px;">
                  {{ wrnameDataMess.todayFinishPlanItemCount == null ? 0 : wrnameDataMess.todayFinishPlanItemCount }}
                </div>
              </el-row>
              <el-row class="tatistic-key">
                今日完成巡检项
              </el-row>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="tatistic-dialog-div">
              <el-row class="tatistic-value">
                <div style="margin-top: 20px;">
                  {{ wrnameDataMess.todayPlanItemCount == null ? 0 : wrnameDataMess.todayPlanItemCount }}
                </div>
              </el-row>
              <el-row class="tatistic-key">
                今日巡检项
              </el-row>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="tatistic-dialog-div">
              <el-row class="tatistic-value">
                <div style="margin-top: 20px;">
                  {{ wrnameDataMess.nofinishRepair == null ? 0 : wrnameDataMess.nofinishRepair }}
                </div>
              </el-row>
              <el-row class="tatistic-key">
                现存维修
              </el-row>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="tatistic-dialog-div">
              <el-row class="tatistic-value">
                <div style="margin-top: 20px;">
                  {{ wrnameDataMess.todayOccuRepairCount == null ? 0 : wrnameDataMess.todayOccuRepairCount }}
                </div>
              </el-row>
              <el-row class="tatistic-key">
                今日维修
              </el-row>
            </div>
          </el-col>
        </el-col>
      </el-row>
      <span slot="footer">
        <el-button size="mini" @click="wrnameDataMessView = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import dateutils from '../utils/dateutils.js'

import "ol/ol.css";
import { Map, View, Feature } from "ol"
import { defaults } from "ol/control"
import { XYZ, Vector as sourceVector } from "ol/source"
import { Tile, Vector as layerVector } from "ol/layer"
import { Point } from "ol/geom"
// import { Style, Circle, Fill } from "ol/style"
import { Style, Icon } from "ol/style"

export default {
  name: 'eshome',

  data () {
    return {
      loading: false,
      queryObj: { starttime: [], endtime: [] },//查询条件 
      dayFaultHis: [],
      faultlist: [],
      faultInfo: {},
      wrnameData: [],
      wrnameDataMess: {},
      map: null,
      layer: null,
      pointLayer: null,
      wrnameDataMessView: false,
    }
  },
  methods: {
    init () {

      this.getOutlinedata()
      // this.configData()
      this.loadDayFaultHis()
      this.getOrgByLongitude()
      setTimeout(() => {
        this.map.getView().setZoom(9)
        this.map.getView().setCenter([126.630809, 45.760969])
      }, 1000);
    },
    configData () {
      this.$ajax.get('/buss/home/configData').then(msg => {
        this.$nextTick(() => {
          this.initMap(msg)
        })
      }).catch(err => {
        this.$message.error(err);
      })
    },
    getOrgByLongitude () {
      this.$ajax.get('/buss/home/getOrgByLongitude').then(msg => {
        this.wrnameData = msg
        this.configData()
      }).catch(err => {
        this.$message.error(err);
      })
    },
    initMap (config) {
      this.layer = new layerVector({
        source: new sourceVector(),
        visible: true
      })
      // 打点图标的图层
      this.pointLayer = new layerVector({
        source: new sourceVector({
          features: []
        })
      })
      this.map = new Map({
        controls: defaults({
          zoom: false
        }),
        layers: [
          new Tile({
            source: new XYZ({
              url: config.url + '/map/{z}/{x}/{y}.png'
            })
          }),
          this.layer,
          this.pointLayer
        ],
        view: new View({
          projection: "EPSG:4326",
          extent: [119.321165, 41.305686, 140.810422, 49.87607],
          // center: [config.longitude, config.latitude],
          center: [86.630809, 45.760969],
          zoom: 6,
          minZoom: 6,
          maxZoom: 18
        }),
        target: "map",
      });
      // let init = 6
      let _this = this
      this.map.getView().on('change:resolution', function () {
        let c = Math.floor(this.getZoom())
        if (c >= 9) {
          _this.showSitesInMap()
        } else if (c < 9) {
          _this.showSitesInMapNo()
        }
      })
      //添加点击事件
      this.map.on("singleclick", e => {
        this.wrnameDataMess = {}
        this.map.forEachFeatureAtPixel(e.pixel, (feature) => {
          console.log(feature.get('mess'))
          this.wrnameDataMessView = true
          this.wrnameDataMess = feature.get('mess');
        })
      })
    },
    showSitesInMapNo () {
      this.wrnameData.forEach(ee => {
        if (ee.longitude != null && ee.latitude != null) {
          let feature = this.layer.getSource().getFeatureById(ee.id)
          if (feature != null) {
            this.layer.getSource().removeFeature(feature)
          }
        }
      })
    },
    showSitesInMap () {
      this.wrnameData.forEach(ee => {
        if (ee.longitude != null && ee.latitude != null) {
          let feature = this.layer.getSource().getFeatureById(ee.id)
          if (feature == null) {
            feature = new Feature({
              geometry: new Point([ee.longitude, ee.latitude])
            })
            feature.setId(ee.id)
            feature.set("mess", ee)
            var iconStyle = new Style({
              image: new Icon({
                anchor: [0.5, 20],
                scale: 1,
                anchorXUnits: 'fraction',
                anchorYUnits: 'pixels',
                src: require('../assets/imgs/station_2_32x32.png')
              })
            })
            feature.setStyle(iconStyle)
            this.layer.getSource().addFeature(feature);
          }
        }
        this.linePointShow = false
      })
    },
    getOutlinedata () {
      this.$ajax.get('/buss/home/get_outlinedata').then((msg) => {
        this.faultInfo = msg
        this.faultlist = msg.nofinishFaults

        //故障完成率
        let alarmchart = this.$echarts.init(document.getElementById('finishRatePanel'))
        let alarmoption = {
          title: {
            text: msg.todayOccuCount == 0 ? 100 : (msg.todaySolveCount * 100 / msg.todayOccuCount).toFixed(1) + "%",
            x: 'center',
            y: 'center',
            textStyle: {
              fontWeight: 'normal',
              color: '#0580f2',
              fontSize: '18'
            }
          },
          color: ['rgba(176, 212, 251, 1)'],
          legend: {
            show: true,
            itemGap: 12
          },

          series: [{
            name: 'Line 1',
            type: 'pie',
            clockWise: true,
            radius: ['50%', '66%'],
            itemStyle: {
              normal: {
                label: {
                  show: false
                },
                labelLine: {
                  show: false
                }
              }
            },
            hoverAnimation: false,
            data: [{
              value: msg.todayOccuCount == 0 ? 100 : (msg.todaySolveCount * 100 / msg.todayOccuCount).toFixed(1),
              name: '故障完成率',
              itemStyle: {
                normal: {
                  color: { // 完成的圆环的颜色
                    colorStops: [{
                      offset: 0,
                      color: '#00cefc' // 0% 处的颜色
                    }, {
                      offset: 1,
                      color: '#367bec' // 100% 处的颜色
                    }]
                  },
                  label: {
                    show: false
                  },
                  labelLine: {
                    show: false
                  }
                }
              }
            }, {
              value: 100 - (msg.todayOccuCount == 0 ? 100 : (msg.todaySolveCount * 100 / msg.todayOccuCount).toFixed(1))
            }]
          }]
        }
        alarmchart.setOption(alarmoption);

        //巡检完成率
        alarmchart = this.$echarts.init(document.getElementById('insFinishRatePanel'))
        alarmoption = {
          title: {
            text: msg.todayPlanItemCount == 0 ? 100 : (msg.todayFinishPlanItemCount * 100 / msg.todayPlanItemCount).toFixed(1) + "%",
            x: 'center',
            y: 'center',
            textStyle: {
              fontWeight: 'normal',
              color: '#0580f2',
              fontSize: '18'
            }
          },
          color: ['rgba(176, 212, 251, 1)'],
          legend: {
            show: true,
            itemGap: 12
          },

          series: [{
            name: 'Line 1',
            type: 'pie',
            clockWise: true,
            radius: ['50%', '66%'],
            itemStyle: {
              normal: {
                label: {
                  show: false
                },
                labelLine: {
                  show: false
                }
              }
            },
            hoverAnimation: false,
            data: [{
              value: msg.todayPlanItemCount == 0 ? 100 : (msg.todayFinishPlanItemCount * 100 / msg.todayPlanItemCount).toFixed(1),
              name: '巡检完成率',
              itemStyle: {
                normal: {
                  color: { // 完成的圆环的颜色
                    colorStops: [{
                      offset: 0,
                      color: '#00cefc' // 0% 处的颜色
                    }, {
                      offset: 1,
                      color: '#367bec' // 100% 处的颜色
                    }]
                  },
                  label: {
                    show: false
                  },
                  labelLine: {
                    show: false
                  }
                }
              }
            }, {
              value: 100 - (msg.todayPlanItemCount == 0 ? 100 : (msg.todayFinishPlanItemCount * 100 / msg.todayPlanItemCount).toFixed(1))
            }]
          }]
        }
        alarmchart.setOption(alarmoption);

      }).catch(err => {
        this.$message.error(err)
      })
    },
    stateFormat (row, type) {
      if (row.state == 1) {
        if (type == 1) {
          row.statename = "待分配"
          return "warning"
        }
        return "待分配"
      } else if (row.state == 2) {
        if (type == 1) {
          row.statename = "待解决"
          return "primary"
        }
        return "待解决"
      } else {
        if (type == 1) {
          row.statename = "已解决"
          return "success"
        }
        return "已解决"
      }

    },
    loadDayFaultHis () {
      this.queryObj.starttime = dateutils.dateFormat("YYYY-mm-01 00:00:00", new Date())
      this.queryObj.endtime = dateutils.dateFormat("YYYY-mm-dd 23:59:59", new Date())
      this.$ajax.get('/buss/statisticfault/dayfaulthis', this.queryObj).then(msg => {
        this.dayFaultHis = msg
        this.initLineDayFaultHis(this.dayFaultHis, "eleDayFaultHis", "")
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },

    initLineDayFaultHis (datelist, idname, title) {

      let myChart = this.$echarts.init(document.getElementById(idname))

      let names = []
      let datechart = []
      for (var i = 0; i < datelist.length; i++) {
        names.push(datelist[i].name)
        datechart.push(datelist[i].value)
      }

      var option = {
        title: {
          text: title,
          textAlign: 'auto'
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          data: names
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '故障数',
            data: datechart,
            type: 'line',
            smooth: true
          }
        ]
      }
      myChart.setOption(option)
    },
    add_fau_tab () {
      if (this.$store.getUser().menus.indexOf('/fault/faultquery') >= 0) {
        this.$emit("add-tab", {
          "id": 48,
          "label": "故障查询",
          "icon": "el-icon-yulanchakan",
          "url": "/fault/faultquery"
        })
      } else {
        this.$message.error("你没有故障查询权限")
      }
    },
    add_ins_tab () {
      if (this.$store.getUser().menus.indexOf('/ins/insmanage') >= 0) {
        this.$emit("add-tab", {
          "id": 65,
          "label": "巡检计划",
          "icon": "el-icon-jihua",
          "url": "/ins/insmanage",
        })
      } else {
        this.$message.error("你没有巡检计划查看权限")
      }
    },
    add_task_tab () {
      if (this.$store.getUser().menus.indexOf('/task/taskquery') >= 0) {
        this.$emit("add-tab", {
          "id": 72,
          "label": "任务查看",
          "icon": "el-icon-chaxun",
          "url": "/task/taskquery",
        })
      } else {
        this.$message.error("你没有任务查看权限")
      }
    },
    add_maintain_tab () {
      if (this.$store.getUser().menus.indexOf('/maintain/maintainquery') >= 0) {
        this.$emit("add-tab", {
          "id": 92,
          "label": "保养查看",
          "icon": "el-icon-paibanchaxun",
          "url": "/maintain/maintainquery"
        })
      } else {
        this.$message.error("你没有保养查看权限")
      }
    },
    add_mat_tab () {
      if (this.$store.getUser().menus.indexOf('/mat/matconsumequery') >= 0) {
        this.$emit("add-tab", {
          "id": 38,
          "label": "物料使用",
          "icon": "el-icon-chakan",
          "url": "/mat/matconsumequery"
        })
      } else {
        this.$message.error("你没有物料使用查看权限")
      }

    },
    add_user_tab () {
      if (this.$store.getUser().menus.indexOf('/system/account') >= 0) {
        this.$emit("add-tab", {
          "id": 12,
          "label": "账户管理",
          "icon": "el-icon-yonghu",
          "url": "/system/account",
        })
      } else {
        this.$message.error("你没有账户管理权限")
      }
    },
    add_repair_tab () {
      if (this.$store.getUser().menus.indexOf('/repair/repairquery') >= 0) {
        this.$emit("add-tab", {
          "id": 12,
          "label": "维修查看",
          "icon": "el-icon-yulanchakan",
          "url": "/repair/repairquery",
        })
      } else {
        this.$message.error("你没有维修查看权限")
      }
    },
    add_duty_tab () {
      if (this.$store.getUser().menus.indexOf('/rostering/rosteringnowduty') >= 0) {
        this.$emit("add-tab", {
          "id": 84,
          "label": "在班人员",
          "icon": "el-icon-jihua",
          "url": "/rostering/rosteringnowduty",
        })
      } else {
        this.$message.error("你没有在班人员权限")
      }
    },
    add_asset_tab () {
      if (this.$store.getUser().menus.indexOf('/asset/asset') >= 0) {
        this.$emit("add-tab", {
          "id": 21,
          "label": "设备管理",
          "icon": "el-icon-shebeizuguanli",
          "url": "/asset/asset",
        })
      } else {
        this.$message.error("你没有设备管理权限")
      }
    },

  },


  mounted () {

    setInterval(this.init(), 30000);//定时器，每30秒刷界面

  },

}
</script>

<style  scoped>
.card-context {
  height: 200px;
}

.title-context {
  height: 160px;
  border-radius: 10px;
  margin-top: 10px;
}

.context-div {
  margin-left: 10px;
  margin-top: 30px;
  text-align: center;
}

.context-value {
  color: rgb(68, 67, 67);
  font-size: 32px;
}

.context-key {
  color: rgb(126, 125, 125);
  font-size: 14px;
  margin-top: 10px;
}

.tatistic-div {
  height: 85px;
  background: #c9e0f6;
  border-radius: 5px;
  margin-top: 10px;
  text-align: center;
}

.tatistic-dialog-div {
  height: 85px;
  background: #e5d7f6;
  border-radius: 5px;
  margin-top: 10px;
  text-align: center;
}

.tatistic-value {
  color: rgb(68, 67, 67);
  margin-top: 6px;
  font-size: 24px;
}

.tatistic-key {
  color: rgb(126, 125, 125);
  margin-top: 10px;
  /* text-align: right; */
  font-size: 12px;
}

.context-icon {
  font-size: 40px;
  font-weight: 500;
  margin-top: -20px;
  margin-right: -10px;
}

.card-table {
  height: calc(100vh - 730px);
}

.card-con {
  height: calc(100vh - 350px);
}

.el-aside {
  /* background-color: #8dccf7; */
  color: rgb(255, 255, 255);
  text-align: center;
  line-height: 90px;
}


.el-main {
  /* background-color: #a2d7f9; */
  color: rgb(247, 251, 251);
  text-align: center;
  line-height: 50px;
}

.map {
  height: 390px;
  width: 100%;
  box-shadow: 0 0 0 0 rgb(0 0 0 / 10%);
  background-color: #fff;
  transition: 0.3s;
  overflow: hidden;
}
</style>
